import React from "react";
import { useFormContext } from "react-hook-form";
import MUploadFile from "@app/components/MUploadFile";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";

export function cleanFileName(filePath) {
  if (!filePath) return "";
  const fileName = filePath.split("/").pop();
  const lastUnderscoreIndex = fileName.lastIndexOf("_");
  if (lastUnderscoreIndex === -1) return fileName;
  const cleanName = fileName.substring(0, lastUnderscoreIndex) + ".RPT";
  return cleanName;
}

export const parseRptFileExe = (content) => {
  return content
    .split('\n')
    .map(line => line.split('|'))
    .filter(arr => arr.length > 1 && arr[1]?.trim() !== '');
};

interface FileUploadAreaExeProps {
  name: string;
}

interface FileUploadAreaExeProps {
  name: string;
  cod_instalacion?: string;
  ref_cliente?: string;
}

const FileUploadAreaExe = ({ name, cod_instalacion, ref_cliente }: FileUploadAreaExeProps) => {
  const { setValue, getValues, watch } = useFormContext();

  const { currentCalculation, importFileFromRoute } = useAnalysis();

  const parseRptFile = (content) => {
    if (name === "source_app_calculation_info_file") {
      const lines: string[][] = parseRptFileExe(content);
      const searchKey = `${cod_instalacion}${ref_cliente}`;
      
      const matchingLine = lines.find(line => line[0] === searchKey);
      
      if (matchingLine) {
        setValue("first_counting_time", matchingLine[1]);
        setValue("calculation_date_countig_file_exe", matchingLine[2]);
        setValue("pico_counts_341", matchingLine[4]);
        setValue("pico_counts_911", matchingLine[5]);
        setValue("detector_file", matchingLine[3]);
      } else {
        alert(`No se encontraron datos relacionados con la referencia: ${searchKey}`);
      }
    }
  };

  const handleDownload = async () => {
    await importFileFromRoute(getValues(name), "DOWNLOAD");
  };
  const isDisabled = Boolean(watch("idResultPreload"));

  return (
    <MUploadFile
      key={`${getValues(name)}_exe`}
      acceptFile=".txt"
      onFileChange={parseRptFile}
      name={`${name}_exe`}
      preloadNameFile={cleanFileName(getValues(name))}
      validation={
        currentCalculation.id ? {} : { required: "Este campo es requerido" }
      }
      downloadFile={currentCalculation.id ? handleDownload : undefined}
      disabled={isDisabled}
    />
  );
};
export default FileUploadAreaExe;
